import { default as Vue, default as _Vue, PluginObject } from 'vue';

export default class Session implements PluginObject<{}> {
  public static install(vue: typeof _Vue, options?: {}) {
    vue.$session = new Session(options);
  }
  public options: {} | undefined;

  constructor(options?: {}) {
    this.options = options;
  }

  public install(vue: typeof _Vue, options?: {}) {
    vue.$session = this;
  }

  public create() {
    localStorage.setItem('user', JSON.stringify({}));
  }

  public destroy() {
    localStorage.removeItem('user');
  }

  public isAuthenticated(): boolean {
    return localStorage.getItem('user') != null;
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $session: Session;
  }
  interface VueConstructor {
    $session: Session;
  }
}

declare module 'vue/types/options' {
  interface ComponentOptions<V extends Vue> {
    session?: Session;
  }
}
